import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import * as Enums from '../../icon/icon.props';
import { AtlNavIconProps } from './nav-icon.props';
import classNames from 'classnames';
import { enumAttributeConverter } from '../../enum-types';
import { getGlobalStyleSheets } from '../../../global-styles';
import '../../icon';
import { ifDefined } from 'lit/directives/if-defined.js';

import * as TagNames from '../layouts.tagnames';

@customElement(TagNames.NavIcon)
export class AtlNavIcon extends LitElement implements AtlNavIconProps {
   declare iconId: string;
   declare iconSource: Enums.IconSource;
   declare iconSize: Enums.IconSizes;
   declare iconSet: Enums.IconSet;
   declare name: string;

   static properties = {
      iconId: { type: String },
      iconSource: {
         type: String,
         converter: enumAttributeConverter(
            Enums.IconSource,
            Enums.IconSource.OpenIconic
         ),
      },
      iconSize: {
         type: String,
         converter: enumAttributeConverter(Enums.IconSizes),
      },
      iconSet: {
         type: String,
         converter: enumAttributeConverter(Enums.IconSet, Enums.IconSet.Solid),
      },
      name: { type: String },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      return html`<atlantis-icon
         iconClassName=${classNames('atl-wc-nav-item kpmg-icon')}
         iconId=${ifDefined(this.iconId)}
         iconSource=${ifDefined(this.iconSource)}
         iconSize=${ifDefined(this.iconSize)}
         iconSet=${ifDefined(this.iconSet)}
         name=${ifDefined(this.name)}
      ></atlantis-icon>`;
   }
}
